<template>
  <div class="gw_title-tooltip gw_title gw_title_small gw_hvr position-relative">
    {{ title }}
    <GwTooltip
      v-if="tooltip"
      :isInside="isInside"
      :tooltip="tooltip"
      class="solfigrstpot_item_title"
      tooltipCssStyle="position: fixed; max-width: clamp(12rem, 36rem, 96vw)"
      tooltipCssClass="gw_title_tooltip"
      style="color: var(--clr-grey-2); --hvr-content-opacity: 0.5"
      icon="mdi mdi-help-circle-outline gw_hvr_content text-small my-auto ml-1"
    />
    <slot />
  </div>
</template>

<script>
import GwTooltip from '@/components/lib/GwTooltip'

export default {
  name: 'GwTitleTooltip',
  components: {
    GwTooltip,
  },
  props: {
    isInside: Boolean,
    title: String,
    tooltip: String,
    placement: { default: () => 'top' },
  },
}
</script>

<style lang="scss">
.gw_title {
  --clr: var(--clr-grey-2);
  --white-space: nowrap;
  --tooltip-white-space: normal;

  display: flex;
  align-items: center;
  color: var(--clr);
  white-space: var(--white-space);
  &_small {
    font-size: 0.875rem;
  }
  &_tooltip {
    white-space: var(--tooltip-white-space);
  }
}
</style>
